import script from "./HeaderBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderBlock.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderBlock.vue?vue&type=style&index=0&id=44384f78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44384f78"]])

export default __exports__